import ArrowLeft from "../assets/svgs/button-arrow-left.svg";
import ArrowRight from "../assets/svgs/button-arrow-right.svg";
import classnames from "classnames";

export default function CircleButton({
  className,
  text = "",
  direction = "left",
  ...props
}) {
  return (
    <button
      className={classnames(
        "flex bg-yellow bg-opacity-10 hover:bg-opacity-30 rounded-full items-center justify-center w-8 h-8 disabled:opacity-30",
        className
      )}
      {...props}
    >
      {direction === "left" ? (
        <>
          <ArrowLeft
            className="w-2 relative -left-px text-yellow"
            aria-hidden={true}
          />
          <span className="sr-only">{text}</span>
        </>
      ) : (
        <>
          <ArrowRight
            className="w-2 relative -right-px text-yellow"
            aria-hidden={true}
          />
          <span className="sr-only">{text}</span>
        </>
      )}
    </button>
  );
}
